import React from "react";
import "../../TvSubscription/TvSubscription.css";
import { useContext } from "react";
import { ContextProvider } from "../../Context";
import { Modal } from "../../Screens/Modal/Modal";
import styles from "../../AirTimePage/AirtimeVtu.module.css";


 const ShowmaxSuccessfulPopup = ({handleReceivedData}) => {
  
   const {
     showmaxSuccessful, 
     setShowmaxSuccessful,
     toggleSideBar,
     showMaxMobileNumber,
     flagResult,
     showMaxSmartCard,
     showMaxEmail,
     selectedOptionShowmax,
  } = useContext(ContextProvider)

  
  const valueWithoutTilde = selectedOptionShowmax.split(" ~ ")[0];
 

  const handleReceipt = ()=> {
    setShowmaxSuccessful(false);
    handleReceivedData();
  }

    return(
       <>
       {showmaxSuccessful &&
            (
            <Modal>
           
       <div className={`${styles.successfulTwo} ${
              toggleSideBar ? "md:w-[45%] lg:ml-[20%] lg:w-[40%]" : "lg:w-[40%]"
            } md:w-[45%] w-[90%] overflow-auto`}>
        <div className="flex justify-between items-center mx-[3%] my-[2%] md:my-[1%]">
        <div>
              <img
                    
                className=" w-[15px] h-[10px] md:w-[24px] md:h-[15px] lg:w-[42px] lg:h-[25px]"
                src="/Images/login/arpLogo.png"
                alt=""
              />
                </div>
            <div>
              <img
                onClick={()=>{
                  setShowmaxSuccessful(false)
                  window.location.reload()
                }}
                className=" w-[18px] h-[18px] md:w-[35px] md:h-[35px] lg:w-[29px] lg:h-[29px]"
                src="/Images/transferImages/close-circle.png"
                alt=""
                  />
              </div>
        </div>
        <hr className="h-[6px] bg-[#04177f] border-none md:h-[10px]" />
        <div className="">
            <div className="text-[12px] my-[4%] font-medium text-center md:text-[20px] md:my-[3%] lg:text-[14px] lg:my-[2%]"
            >Subscription Successful</div>
            <img
              className="w-[50px] h-[50px] mx-auto mb-[2%] lg:w-[70px] lg:h-[70px]"
              src="./Gif/checkMarkGif.gif"
              alt="/"
            />
            <div className="text-[#7C7C7C] w-[97%] mx-auto text-[10px] font-bold text-center mb-2 md:pb-2 lg:pb-3 md:text-[14px] lg:text-[14px]">You have successfully subscribed &nbsp;
                  <span className="text-black font-bold text-[10px] md:text-[16px] lg:text-[14px]">{valueWithoutTilde}</span>&nbsp;
                  From Your {" "}
                  {flagResult} {" "} to
            </div>
            <div className="flex flex-col gap-2 lg:gap-4 mt-4">
            <div className="flex text-[10px] md:text-[14px] w-[90%] mx-auto justify-between lg:text-[15px] font-semibold">
                    <span className="text-[#7C7C7C]">Decoder Type</span>
                    <div className="flex gap-1">
                      <img src="./Images/TvSubscription/showmaxIcon.svg" alt="" className="md:w-[60px] md:h-[15px] lg:w-[80px] lg:h-[16px]" />
                      <span>Showmax</span>
                    </div>
                    
                </div>
                <div className="flex text-[10px] md:text-[14px] w-[90%] mx-auto justify-between lg:text-[15px] font-semibold">
                    <span className="text-[#7C7C7C]">Package</span>
                    <span>{selectedOptionShowmax}</span>
                </div>
                {/* <div className="flex text-[10px] md:text-[14px] w-[90%] mx-auto justify-between lg:text-[15px] font-semibold">
                    <span className="text-[#7C7C7C]">Smartcard / IUC Number</span>
                    <span>{showMaxSmartCard}</span>
                </div>
                <div className="flex text-[10px] md:text-[14px] w-[90%] mx-auto justify-between lg:text-[15px] font-semibold">
                    <span className="text-[#7C7C7C]">Card Name</span>
                    <span>{userVerifiedName}</span>
                </div> */}
                <div className="flex text-[10px] md:text-[14px] w-[90%] mx-auto justify-between lg:text-[15px] font-semibold">
                    <span className="text-[#7C7C7C]">Phone Number</span>
                    <span>{showMaxMobileNumber}</span>
                </div>
                <div className="flex text-[10px] md:text-[14px] w-[90%] mx-auto justify-between lg:text-[15px] font-semibold">
                    <span className="text-[#7C7C7C]">Email</span>
                    <span>{showMaxEmail}</span>
                </div>
                <div className="flex text-[10px] md:text-[14px] w-[90%] mx-auto justify-between font-semibold lg:text-[15px]">
                    <span className="text-[#7C7C7C]">Payment Method</span>
                    <span>{flagResult}</span>
                </div>
                {/* <div className="flex text-[10px] md:text-[14px] w-[90%] mx-auto justify-between font-semibold lg:text-[15px]">
                    <span className="text-[#7C7C7C]">Order Number</span>
                    <span>0124yend44</span>
                </div> */}
            </div>
        </div>
        <div className="bg-[#F2FAFF] mx-10 h-[45px] my-5 flex justify-between items-center px-[4%] md:h-[65px] lg:h-[75px]">
            <div className="text-[7px] text-center mx-auto w-[171px] md:text-[14px] md:w-[80%] lg:text-[14px] font-semibold">
            The decoder has been subscribed successfully. Please kindly confirm from the smartcard / iuc. You can contact us for any further assistance.
            </div>yar
        </div>

        <div className="flex w-full justify-center items-center gap-[10px] pb-4 md:gap-[8.59px] lg:gap-[15px] md:pb-2">
    
                <button
                    onClick={() => { setShowmaxSuccessful(false); 
                      window.location.reload();}} 
                className={`bg-[#04177f] w-[111px] lg:w-[200px] md:w-[99px] h-[40px] md:h-[24px] lg:h-[42px] lg:my-[2%] flex justify-center items-center cursor-pointer text-[12px] md:text-[12px] lg:text-[16px] font-semibold text-white rounded-[6px] md:rounded-[7px] lg:rounded-[12px]`}
              >
                Done
                  </button>
            
           
                <button onClick={()=> handleReceipt()}
                style={{boxShadow : '0px 0px 2.0368096828460693px 0px #00000040'}} className={`border-[1px]  w-[111px] lg:w-[200px] md:w-[99px] h-[40px] md:h-[24px] lg:h-[42px] lg:my-[2%] flex justify-center items-center cursor-pointer text-[12px] md:text-[12px] lg:text-[16px] font-semibold rounded-[6px] md:rounded-[7px] lg:rounded-[12px]`}
                >
                  Receipt
                </button>
           
        </div>
       </div>   
            </Modal>
          )}
       </>
    )
}


export default ShowmaxSuccessfulPopup